import cn from 'classnames'

export const ErrorMessage = ({ message, className }) => (
  <span className={cn('text-xs text-red-500', className)}>{message}</span>
)
